import * as React from "react";
import ButtonBase from "@material-ui/core/ButtonBase";
import type { UiBaseProps } from "../uiProps.utils";

export type PressableProps = UiBaseProps & {
  disabled?: boolean;
  title?: string;
  onClick?: React.MouseEventHandler<HTMLElement>;
};

// A bare tappable surface with a ripple: no padding, border or colour of its own, so callers set them inline.
export const Pressable: React.FC<PressableProps> = (props) => <ButtonBase {...props} />;
